import DataExportAthlete from "./DataExportAthlete";

/**
 * This will later hold multiple export routes
 * {@link OS-300|https://outputsports.atlassian.net/browse/OS-300}
 */
export default DataExportAthlete;
